<template>
  <v-dialog v-model="show" content-class="elevation-0" fullscreen>
    <div style="margin-top: 150px">
      <div class="stories-wrapper">
        <div @click="closeStories" class="close"></div>
        <div class="stories">
          <div
            v-for="(story, index) in stories"
            :key="index"
            class="story"
            :style="
              index === indexSelected
                ? `transform: translate(0px)`
                : `transform: translate(${calculateTransform(
                    index
                  )}px) scale(0.3);cursor:pointer;`
            "
            @click="index !== indexSelected ? selectSlide(index) : ''"
          >
            <div class="story__source" id="storyBody">
              <!-- Story Body File Start -->
              <div
                class="story__source"
                style="z-index: 77777"
                @click="toggleStory(story, index)"
              >
                <video
                  :id="getSrc(story, index).url"
                  v-if="getSrc(story, index).type === 'video'"
                  :src="getSrc(story, index).url"
                  :autoplay="index === indexSelected"
                  controlsList="nodownload"
                ></video>
                <img v-else :src="getSrc(story, index).url" alt="" />
              </div>

              <!-- Story Body File End -->

              <!-- Story Text Start -->
              <div :class="'storyText'" @click="toggleStory(story, index)">
                <div :style="getStoryTextStyle(story, index)">
                  {{ getStoryInfo(story, index, "text") }}
                </div>
              </div>
              <!-- Story Text End -->

              <!-- Story Header Start -->
              <div class="story__header" v-if="index === indexSelected">
                <div class="time">
                  <div
                    class="time__item"
                    v-for="(elm, index) in story.images.length"
                    :key="index"
                  >
                    <div
                      class="time__fill"
                      :style="
                        index === key
                          ? `width: ${percent}%`
                          : key > index
                          ? `width:100%`
                          : `width:0%`
                      "
                    ></div>
                  </div>
                </div>
                <div class="story__top">
                  <div class="user">
                    <div class="user__image">
                      <!-- <v-img :src="story.picture" /> -->
                      <v-avatar size="50">
                        <v-img :src="story.picture" />
                      </v-avatar>
                    </div>
                    <div class="user__name">
                      <div>
                        <div>
                          {{ story.username }}
                          ·
                          <departmant-icon :departmentName="story.department" />
                        </div>
                        <div class="story__time">
                          {{ getStoryInfo(story, index, "time") }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <v-spacer />
                  <div class="user">
                    <v-icon color="white" v-if="isPinned(story, index)"> mdi-pin </v-icon>
                    <v-menu bottom left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          text
                          v-bind="attrs"
                          v-on="on"
                          icon
                          @click="pauseStory(story, index)"
                          class="text-capitalize mr-3 white--text"
                          color="soothing_breeze"
                        >
                          <v-icon size="30">mdi-dots-horizontal</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          link
                          v-for="(item, i) in menuItems(story, index)"
                          :key="i"
                          @click="menuClickEvent(item.key, story, index)"
                        >
                          <v-list-item-title>{{
                            item.title
                          }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </div>
              </div>
              <!-- Story Header End -->

              <!-- Comment Start -->
              <div
                class="comment"
                v-if="index === indexSelected && !story.myStory"
              >
                <v-layout row wrap align-center my-1 px-2 class="storyComment">
                  <v-text-field
                    class="px-2 mr-2 custom-placeholer-color"
                    color="white"
                    style="border-width: 1rem"
                    rounded
                    outlined
                    hide-details
                    full-width
                    @focus="commentFocus(story, index)"
                    :placeholder="$t('placeHolder.writeMessage')"
                  >
                  </v-text-field>
                  <v-btn
                    outlined
                    rounded
                    class="text-capitalize mt-0 mr-3"
                    color="white"
                    >{{ $t("buttons.send") }}</v-btn
                  >
                </v-layout>
              </div>
              <!-- Comment End -->

              <!-- ViewList Start -->
              <div
                class="comment"
                v-if="index === indexSelected && story.myStory"
              >
                <v-layout row wrap my-1 px-2 class="storyComment">
                  <v-bottom-sheet
                    v-model="sheet"
                    scrollable
                    @click:outside="showViewList(false, story, index)"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        text
                        color="white"
                        class="text-lowercase ma-2 ml-4"
                        @click="showViewList(true, story, index)"
                      >
                        <v-icon left> mdi-eye </v-icon>
                        {{ `${story.viewCount} ${$t("buttons.viewCount")}` }}
                      </v-btn>
                    </template>
                    <v-card>
                      <v-subheader>
                        {{ $t("title.viewCount", { count: story.viewCount }) }}
                        <v-spacer />

                        <v-btn
                          class="mt-2"
                          fab
                          text
                          dark
                          small
                          color="defaultColor"
                          @click="showViewList(false, story, index)"
                        >
                          <v-icon dark> mdi-close </v-icon>
                        </v-btn>
                      </v-subheader>
                      <v-card-text style="height: 300px">
                        <v-list>
                          <div
                            v-for="(item, index) in story.viewList"
                            :key="item.Id.concat(index.toString())"
                          >
                            <user-list-item
                              :item="item.User"
                              :avatar="item.User.Avatar"
                              :fullName="item.User.FullName"
                              :department="item.User.Department"
                              :company="item.User.Company"
                              :userId="item.User.Id"
                              :noBg="true"
                              :divider="
                                story.viewList.length == index + 1
                                  ? false
                                  : true
                              "
                            />
                          </div>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-bottom-sheet>
                </v-layout>
              </div>
              <!-- ViewList End -->

              <div class="story__body" style="background-color: red !important">
                <div class="user" v-if="index !== indexSelected">
                  <div
                    class="user__image"
                    :style="
                      getNotViewedIndex(story) === -1
                        ? `background: #FFFFFF`
                        : ''
                    "
                  >
                    <img :src="story.picture" alt="" />
                  </div>
                  <div class="user__name">
                    {{ story.username }}
                  </div>
                </div>
                <slot
                  v-if="showInnerContent && index === indexSelected"
                  name="innerContent"
                  :story="story"
                ></slot>
              </div>
            </div>

            <div
              v-if="
                index === indexSelected && !(indexSelected == 0 && key == 0)
              "
              class="story__icon story__icon--prev"
              @click="prev(index)"
            ></div>
            <div
              v-if="
                index === indexSelected &&
                !(
                  indexSelected == stories.length &&
                  key == stories[indexSelected].length
                )
              "
              class="story__icon story__icon--next"
              @click="next(index)"
            ></div>
            <slot
              v-if="showOuterContent && index === indexSelected"
              name="outerContent"
              :story="story"
            ></slot>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import DepartmantIcon from "../General/DepartmantIcon.vue";
import UserListItem from "../Users/UserListItem.vue";
import StoryService from "../../services/StoryService";
import PostService from "../../services/PostService";
export default {
  name: "Stories",
  props: {
    stories: {
      type: Array,
      required: true,
    },
    duration: {
      type: Number,
      default: 3000,
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
    showInnerContent: {
      type: Boolean,
      default: false,
    },
    showOuterContent: {
      type: Boolean,
      default: false,
    },
    visible: Boolean,
  },
  components: {
    DepartmantIcon,
    UserListItem,
  },
  data: function () {
    {
      return {
        indexSelected: 0,
        difference: 0,
        key: 0,
        percent: 0,
        timer: 0,
        progress: 0,
        interval: 0,
        isPaused: false,
        newDur: 0,
        pausePer: 0,
        sheet: false,
        menuItemAdmin: [{ title: this.$i18n.t("menu.delete"), key: "delete" }],
        menuItemMyPin: [
          { title: this.$i18n.t("menu.delete"), key: "delete" },
          { title: this.$i18n.t("menu.pin"), key: "pin" },
        ],
        menuItemMyUnPin: [
          { title: this.$i18n.t("menu.delete"), key: "delete" },
          { title: this.$i18n.t("menu.unPin"), key: "unPin" },
        ],
        menuItemReport: [{ title: this.$i18n.t("menu.report"), key: "report" }],
        storyViewdIds: [],
        openModall: false,
        flag: false,
      };
    }
  },
  computed: {
    isAllStoriesEnd() {
      return (
        this.indexSelected >= this.stories.length - 1 &&
        this.isCurrentAllImagesEnd
      );
    },
    isCurrentAllImagesEnd() {
      return this.key >= this.stories[this.indexSelected].images.length - 1;
    },
    show: {
      get() {
        // if(this.visible && !this.flag){
        //   console.log('toggle story')
        //   this.flag = true
        //   this.isPaused = true
        //   this.toggleStory(this.stories[this.currentIndex]);
        // }
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.closeStories();
        }
      },
    },
  },
  methods: {
    getSrc(story, index) {
      const viewedIndex = this.getLastViewedIndex(story);
      return index === this.indexSelected
        ? {
            url: story.images[this.key].url,
            type: story.images[this.key].type,
          }
        : {
            url: story.images[viewedIndex].url,
            type: story.images[viewedIndex].type,
          };
    },
    getNotViewedIndex(story) {
      return story.images.findIndex((item) => !item.viewed);
    },
    getLastViewedIndex(story) {
      const keyIndex = this.getNotViewedIndex(story);
      const index = story.images.length - 1;
      return keyIndex === -1 ? index : keyIndex;
    },
    selectSlide(index) {
      this.isPaused = false;
      this.difference += this.indexSelected - index;
      this.stopVideo(this.stories[this.indexSelected].images[this.key].url);
      this.indexSelected = index;
      this.key = this.getLastViewedIndex(this.stories[this.indexSelected]);
      //this.reset();
      setTimeout(() => {
        this.isPaused = !this.isPaused;
        this.toggleStory(this.stories[this.indexSelected], this.indexSelected);
      }, 200);
    },
    onAllStoriesEnd() {
      this.difference = 0;
      this.indexSelected = 0;
      this.key = 0;
      this.closeStories();
      //this.$emit("allStoriesEnd");
    },
    onCurrentAllImagesEnd(index) {
      this.difference += index - (index + 1);
      this.stopVideo(this.stories[this.indexSelected].images[this.key].url);
      this.stories[index].images[this.key].viewed = true;
      this.indexSelected++;
      this.key = this.getLastViewedIndex(this.stories[this.indexSelected]);
      this.$emit("сurrentAllImagesEnd", index);
    },
    onCurrentImageEnd(index) {
      //this.stories[index].images[this.key].viewed = true;
      this.$emit("сurrentImageEnd", this.key);
      this.key++;
    },
    next(index) {
      this.isPaused = false;
      if (this.isAllStoriesEnd) {
        this.onAllStoriesEnd();
        this.reset();
      } else if (this.isCurrentAllImagesEnd) {
        setTimeout(() => {
          this.onCurrentAllImagesEnd(index);
          this.percent = 0;
          clearInterval(this.interval);
          clearInterval(this.progress);
          this.newDur = 0;
          this.stopVideo(this.stories[this.indexSelected].images[this.key].url);
        });
        setTimeout(() => {
          this.isPaused = !this.isPaused;
          this.toggleStory(
            this.stories[this.indexSelected],
            this.indexSelected
          );
        }, 200);
      } else {
        this.stories[this.indexSelected].images[this.key].viewed = true;
        this.key++;
        this.reset();
      }
    },
    prev(index) {
      this.isPaused = false;
      if (this.indexSelected <= 0 && this.key <= 0) {
        this.key = 0;
        this.reset();
      } else if (this.key <= 0) {
        // Without delay
        this.stopVideo(this.stories[this.indexSelected].images[this.key].url);
        setTimeout(() => {
          this.difference += index - (index - 1);
          this.indexSelected--;
          this.key = this.getLastViewedIndex(this.stories[this.indexSelected]);
        });
        this.percent = 0;
        clearInterval(this.interval);
        clearInterval(this.progress);
        this.newDur = 0;

        setTimeout(() => {
          this.isPaused = !this.isPaused;
          this.toggleStory(
            this.stories[this.indexSelected],
            this.indexSelected
          );
        }, 100);
      } else {
        this.key--;
        this.stories[this.indexSelected].images[this.key].viewed = false;
        this.reset();
      }
    },
    autoPlay() {
      if (this.isAllStoriesEnd) {
        this.onAllStoriesEnd();
      } else if (this.isCurrentAllImagesEnd) {
        this.onCurrentAllImagesEnd(this.indexSelected);
      } else {
        this.onCurrentImageEnd(this.indexSelected);
      }
      this.reset();
    },
    play() {
      try {
        this.createView(this.stories[this.indexSelected].images[this.key].id);
      } catch (error) {}

      let duration = this.stories[this.indexSelected].images[this.key].duration;
      duration ? (duration = duration * 100) : (duration = 10000);
      this.timer = new Date().getTime();
      this.progress = setInterval(() => {
        // forward
        let time = new Date().getTime();
        if (this.newDur > 0) {
          this.percent =
            this.pausePer + Math.floor((100 * (time - this.timer)) / duration);
        } else {
          this.percent = Math.floor((100 * (time - this.timer)) / duration);
        }
      }, duration / 100);
      if (this.newDur > 0) {
        this.interval = setInterval(this.autoPlay, this.newDur);
      } else {
        this.interval = setInterval(this.autoPlay, duration);
      }
    },
    reset() {
      this.percent = 0;
      clearInterval(this.interval);
      clearInterval(this.progress);
      this.newDur = 0;
      this.stopVideo(this.stories[this.indexSelected].images[this.key].url);
      this.play();
    },
    pauseStory(story = null, index = null) {
      if (story && index > -1) {
        let url = this.getStoryInfo(story, index, "url");
        let type = this.getStoryInfo(story, index, "type");
        let event = null;
        if (type == "video") {
          event = {
            target: {
              nodeName: "VIDEO",
              id: url,
            },
          };
        }

        if (type == "video") {
          this.toggleVideo("pause", event);
        }
      }
      this.isPaused = true;
      this.pausePer = this.percent;
      clearInterval(this.progress);
      clearInterval(this.interval);
      let duration = this.getStoryInfo(story, index, "duration");
      duration ? (duration = duration * 100) : (duration = 10000);
      this.newDur = duration - (this.pausePer * duration) / 100;
    },
    playStory(story = null, index = null) {
      if (story && index > -1) {
        let url = this.getStoryInfo(story, index, "url");
        let type = this.getStoryInfo(story, index, "type");
        let event = null;
        if (type == "video") {
          event = {
            target: {
              nodeName: "VIDEO",
              id: url,
            },
          };
        }
        if (type == "video") {
          this.toggleVideo("play", event);
        }
      }

      this.isPaused = false;
      this.play();
    },
    toggleVideo(type, event) {
      if (event.target.nodeName == "VIDEO") {
        const video = document.getElementById(event.target.id);
        if (video) {
          video[type]();
        }
      }
    },
    stopVideo(id) {
      const video = document.getElementById(id);
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    },
    calculateTransform(index) {
      if (
        this.indexSelected - index === -1 ||
        this.indexSelected - index === 1
      ) {
        return 315 * (index + this.difference);
      }
      if (index > this.indexSelected) {
        return (315 + 315 * (index + this.difference)) * 0.5;
      } else {
        return Math.abs((315 - 315 * (index + this.difference)) * 0.5) * -1;
      }
    },
    closeStories() {
      this.stopVideo(this.stories[this.indexSelected].images[this.key].url);
      //this.reset();
      this.percent = 0;
      clearInterval(this.interval);
      clearInterval(this.progress);
      this.newDur = 0;
      this.stopVideo(this.stories[this.indexSelected].images[this.key].url);
      for (let index = 0; index < this.stories.length; index++) {
        this.pauseStory(this.stories[index], index);
      }
      this.currentIndex = -1;
      this.selectSlide(0);
      this.$emit("closeStories");
    },
    commentFocus(story, index) {
      //TODO: Mesaj focusta duraklatma kontrol edilecek. div @click dışına alınacak
      this.isPaused
        ? this.playStory(story, index)
        : this.pauseStory(story, index);
      const video = document.getElementById(
        this.stories[this.indexSelected].images[this.key].url
      );
      if (video) {
        video.pause();
        //video.currentTime = 0;
      }
      this.pauseStory(story, index);
    },
    showViewList(status, story, index) {
      !status ? this.playStory(story, index) : this.pauseStory(story, index);
      this.sheet = status;
    },
    menuItems(story, key, index) {
      if (story.myStory) {
        if (story.images[this.key].isPinned) {
          return this.menuItemMyUnPin;
        } else {
          return this.menuItemMyPin;
        }
      } else {
        if (this.$store.state.user.Type.toLowerCase() != "standart") {
          return this.menuItemAdmin;
        } else {
          return this.menuItemReport;
        }
      }
    },
    isPinned(story) {
      if (story.myStory) {
        if (story.images[this.key].isPinned) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    menuClickEvent(event, story, index) {
      const id = this.getActiveStoryId(story, index);
      event == "report"
        ? this.reportStory(id, story, index)
        : this.clickMyStory(id, event, story, index);
    },
    clickMyStory(id, event, story, index) {
      switch (event) {
        case "delete":
          this.deleteStory(id);
          break;
        case "pin":
          this.pinStory(id, story, index);
          break;
        case "unPin":
          this.unPinStory(id, story, index);
      }
    },
    deleteStory(id) {
      StoryService.deleteStory(id)
        .then((res) => {
          showSuccess(this.$t("description.successDeleteContent"));
          setTimeout(() => {
            this.$router.go();
          }, 1000);
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {});
    },
    pinStory(id, story, index) {
      StoryService.pinStory(id)
        .then((res) => {
          //showSuccess(this.$t("description.pinSuccess"));
          story.images[this.key].isPinned = true
          this.toggleStory(story, index);
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {});
    },
    unPinStory(id, story, index) {
      StoryService.unPinStory(id)
        .then((res) => {
          //showSuccess(this.$t("description.pinSuccess"), "bottom");
          story.images[this.key].isPinned = false
          this.toggleStory(story, index);
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {});
    },
    reportStory(id, story, index) {
      const body = {
        RelatedEntityId: id,
        RelatedEntityType: "story",
        Reason: {
          Id: "722d14a5cd3a7547af4cb612",
          Reason: "Diğer",
          ReasonType: "story",
          Status: 0,
          IsAllGroups: false,
        },
      };
      PostService.complainPost(body)
        .then((res) => {
          showSuccess(this.$t("description.successReport"));
          this.toggleStory(story, index);
        })
        .catch(async (err) => {
          console.log("err :", err);
          showError(err);
        })
        .then(() => {});
    },
    getActiveStoryId(story, index) {
      const viewedIndex = this.getLastViewedIndex(story);
      return index === this.indexSelected
        ? story.images[this.key].id
        : story.images[viewedIndex].id;
    },
    getStoryTextStyle(story, index) {
      let textColor = this.getStoryInfo(story, index, "textColor");
      let textLocation = this.getStoryInfo(story, index, "textLocation");
      let textType = this.getStoryInfo(story, index, "textType");

      if (textType.includes("Bold")) {
        textType = "bold";
      } else if (textType.includes("Light")) {
        textType = "400";
      } else {
        textType = "500";
      }

      if (textLocation < 0.2) {
        textLocation = 0.2;
      } else if (textLocation > 0.4) {
        textLocation = 0.8;
      } else {
        textLocation = 0.5;
      }
      return `color:${textColor}; top:calc((751px) * ${textLocation}); font-weight:${textType}; position:absolute; textAlign:center;, paddingLeft:20px; paddingRight:20px; width:100%`;
    },
    getStoryInfo(story, index, field) {
      const viewedIndex = this.getLastViewedIndex(story);
      return index === this.indexSelected
        ? story.images[this.key][field]
        : story.images[viewedIndex][field];
    },
    toggleStory(story, index) {
      this.isPaused
        ? this.playStory(story, index)
        : this.pauseStory(story, index);
    },
    createView(id) {
      if (!this.storyViewdIds.includes(id)) {
        const body = {
          RelatedEntityId: id,
          Type: "story",
        };
        StoryService.createViewStory(body)
          .then((res) => {
            this.storyViewdIds.push(id);
            this.setItemView(id);
          })
          .catch((err) => {
            console.log("error story view");
            this.setItemView(id);
            //showError(err);
          });
      }
    },
    setItemView(id) {
      let indexOne = this.stories[this.indexSelected].indexOne;
      let indexTwo = this.stories[this.indexSelected].images[this.key].indexTwo;
      this.$emit("viewedStory", { indexOne, indexTwo });
    },
  },
  watch: {
    currentIndex: function (val, oldVal) {
      if (val != oldVal && val != -1) {
        this.selectSlide(this.currentIndex);
      }
    },
  },
  mounted() {
    // console.log("OK");
    // this.openModall = false;
    // this.playStory(this.stories[this.currentIndex], 0);
    // setTimeout(() => {
    //   this.openModall = true;
    // }, 500);
    //this.play();
    // setTimeout(() => {
    //   console.log('current Index :' ,this.stories[this.currentIndex])
    //   this.playStory(this.stories[this.currentIndex], 0);
    // }, 1000);
    //this.selectSlide(this.currentIndex);
    //this.selectSlide(0);
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.comment {
  position: absolute;
  z-index: 99999;
  bottom: 0;
  width: 100%;
}

.storyText {
  position: absolute;
  z-index: 88888;
  width: 100%;
  height: 751px;
  top: 0;
}

.stories-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(16, 16, 16, 0.98);
  font-family: sans-serif;
}

.stories {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.story {
  position: absolute;
  transition: transform 0.2s cubic-bezier(0.4, 0, 1, 1);

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  &__source {
    position: relative;
    border-radius: 16px;
    background: #000000;
    width: 414px;
    height: 751px;
    background-size: contain;

    @media screen and (max-width: 768px) {
      width: 100%;
      height: auto;
      flex: 1 1 auto;
    }

    img,
    video {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
    }
  }

  &__header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 8px 11px;
    z-index: 99999;
  }

  &__time {
    font-size: 12px;
    line-height: 20px;
    color: #ffffff;
  }

  &__top {
    display: flex;
    align-items: center;
  }

  &__body {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99999;

    .user {
      position: absolute;
      bottom: 30px;
      left: 50%;
      transform: translateX(-50%);

      @media screen and (max-width: 768px) {
        display: none;
      }
    }

    .user__name {
      display: none;
    }

    .user__image {
      width: 140px;
      height: 140px;
      background: linear-gradient(180deg, #4c7cf6 0%, #6200c3 100%);
      margin: 0;
      padding: 5px;

      img {
        border: 5px solid #ffffff;
        border-radius: 100%;
      }
    }
  }

  &__icon {
    width: 24px;
    height: 24px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 50px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;

    @media screen and (max-width: 768px) {
      top: 0;
      bottom: 0;
      transform: none;
      width: 100px;
      height: auto;
      background: none;
    }

    &:before {
      content: "";
      position: absolute;
      top: 8px;
      left: 9px;
      border: solid #323232;
      border-width: 0 2px 2px 0;
      display: inline-block;
      padding: 3px;
      transform: rotate(135deg);
      border-radius: 1px;

      @media screen and (max-width: 768px) {
        content: none;
      }
    }

    &--prev {
      left: -35px;

      @media screen and (max-width: 768px) {
        left: 0;
      }
    }

    &--next {
      right: -35px;
      transform: translateY(-50%) rotate(180deg);

      @media screen and (max-width: 768px) {
        right: 0;
        transform: none;
      }
    }
  }
}

.user {
  display: flex;
  align-items: center;

  &__image {
    width: 50px;
    height: 50px;
    border-radius: 100px;
    overflow: hidden;
    margin-right: 8px;
    background-color: white;

    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
  }

  &__name {
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    color: #ffffff;
    margin-right: 5px;
  }
}

.time {
  display: flex;
  margin-bottom: 10px;

  &__item {
    position: relative;
    width: 100%;
    height: 2px;
    margin-right: 4px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 4px;

    &:last-child {
      margin-right: 0;
    }
  }

  &__fill {
    position: absolute;
    width: 100%;
    background: #ffffff;
    height: 2px;
  }
}

.close {
  position: absolute;
  width: 50px;
  height: 50px;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:after {
    content: "\00d7";
    color: #ffffff;
    font-weight: 100;
    font-size: 35px;
  }
}
</style>
